export enum AuthMethod {
  OAuth,
  HostSso,
}

export interface IAuthContext {
  getAccessToken(): string,
  getSubstrateNotesToken(): string | undefined,
  refresh(): Promise<void>,
  getAuthMethod(): AuthMethod
}
